import { Box } from '@mui/material';
import { SegmentTag } from 'types/global';
import { SignInBanner } from '../SignInDialogs/SignInBanner';
import { MarketingBanner, MarketingBannerProps } from '../MarketingBanner';

export const RowBanner: React.FC<{
  segment: SegmentTag;
  isAuthenticated: boolean;
  searchMarketingBannerProps: MarketingBannerProps;
  setShowRegisterModal: (a: boolean) => void;
}> = ({
  segment,
  setShowRegisterModal,
  searchMarketingBannerProps,
  isAuthenticated
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      {!isAuthenticated ? (
        <SignInBanner
          position="list"
          segment={segment}
          setShowRegisterModal={setShowRegisterModal}
        />
      ) : (
        <MarketingBanner {...searchMarketingBannerProps} />
      )}
    </Box>
  );
};
